export function addAttributesToOuterLinks() {
    const links = Array.from(document.querySelectorAll('a[href^="http://"], a[href^="https://"]'));
    const currentHostname = window.location.hostname;

    links.forEach(function (link) {
        if (!link.href.includes(currentHostname)) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "nofollow");
        }

        if (link.href.endsWith(".pdf") || link.href.endsWith(".html")) {
            link.setAttribute("target", "_blank");
        }
    });
}

export function backToTop() {
    const backToTopButton = document.querySelector(".back-to-top");
    if (backToTopButton) {
        backToTopButton.addEventListener("click", function () {
            const lenis = window.__lenis;
            if (lenis && typeof lenis.scrollTo === 'function') {
                lenis.scrollTo(0, { immediate: false });
            } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        });
    }
}

export function anchorScroll(anchor, isDataAnchor = false) {

    const anchorButtons = Array.from(document.querySelectorAll(".btn-anchor"));
    anchorButtons.forEach(function (button) {
        let targetAnchor = null;
        if (button.getAttribute("href") === null) {
            targetAnchor = button.getAttribute("data-anchor");
        } else {
            targetAnchor = button.getAttribute("href");
        }

        if (!targetAnchor) return;

        button.addEventListener("click", function () {
            gotoAnchor(targetAnchor, false, button);
        });
    });

    if (window.location.hash) {
        // Rimuovo il carattere # e controllo se esiste un elemento con quell'id o un data-anchor
        let hash = window.location.hash.replace("#", "");

        setTimeout(function () {
            if (document.getElementById(hash) || document.querySelector(`[data-anchor="${hash}"]`)) {
                gotoAnchor(hash, true, null);
            }
        }, 100);
    }
    
}

function getTemplatePageNavOffset(targetElement, sourceButton = null) {
    const isFromTemplateNav = sourceButton instanceof Element && !!sourceButton.closest('.template-page-nav');
    const isTemplateNavTarget = targetElement instanceof Element && targetElement.classList.contains('template-page-nav-target');

    if (!isFromTemplateNav && !isTemplateNavTarget) {
        return 0;
    }

    const rootStyles = window.getComputedStyle(document.documentElement);
    const navHeightVar = parseFloat(rootStyles.getPropertyValue('--template-page-nav-height'));

    if (!Number.isFinite(navHeightVar) || navHeightVar <= 0) {
        return 0;
    }

    return -navHeightVar;
}

function gotoAnchor(anchor, isDataAnchor = false, sourceButton = null) {
    if (!anchor) return;

    if (isDataAnchor) {
        anchor = `[data-anchor="${anchor}"]`;
    }

    const targetElement = document.querySelector(anchor);
    if (targetElement) {
        const offset = getTemplatePageNavOffset(targetElement, sourceButton);
        const lenis = window.__lenis;
        if (lenis && typeof lenis.scrollTo === 'function') {
            lenis.scrollTo(targetElement, { duration: 1.2, easing: (t) => 1 - Math.pow(1 - t, 3), offset });
        } else {
            const top = window.scrollY + targetElement.getBoundingClientRect().top + offset;
            window.scrollTo({ top, behavior: "smooth" });
        }
    }
}
